import { HttpContextToken } from '@angular/common/http';

export const EXPECTED_ORDER_NOT_FOUND = new HttpContextToken<boolean>(() => false);
